import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  DialogActions,
  Slide
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import WarningIcon from '@material-ui/icons/Warning'
import { useStyles } from './Styles'
import { FormLoader } from '../../../../Loader/FormLoader'
import { CurrencyConsumer } from '../../../../../CurrencyContext'

const Transition = React.forwardRef(function Transition (props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const DeleteCurrency = ({
                          index, data, setData, setCount,
                          handleDeleteCurrencyDialog, viewDeleteCurrencyDialog, openDeleteCurrencyDialog
                        }) => {
  const classes = useStyles()

  return (
    <CurrencyConsumer>
      {({ deleteCurrencyLoading, handleDeleteCurrency }) => (
        <>
          {!!viewDeleteCurrencyDialog &&
          <Dialog
            keepMounted
            fullWidth
            maxWidth={'sm'}
            open={openDeleteCurrencyDialog}
            classes={{ paper: classes.NewOrderDialogPaper }}
            TransitionComponent={Transition}
            onClose={handleDeleteCurrencyDialog}
            aria-labelledby="BasicInfoDialog"
            aria-describedby="BasicInfoDialog"
          >
            <IconButton
              edge={false}
              className={classes.NewOrderDialogClose}
              color="inherit"
              aria-label="close dialog"
              onClick={handleDeleteCurrencyDialog}
            >
              <CloseIcon/>
            </IconButton>
            <DialogContent className={classes.NewOrderDialogContent}>
              {!!deleteCurrencyLoading && <FormLoader loading={true}/>}
              <Box px={4} pt={4} pb={1} className={classes.DeleteOrderWrapper}>
                <WarningIcon className={classes.DeleteWarningIcon}/>
                <p><FormattedMessage id='Currencies.DeleteConfirmation' values={{ name: data[index]?.name || '' }}/></p>
              </Box>
            </DialogContent>
            <DialogActions className={classes.NewOrderDialogFooter}>
              <Button size="large" variant="contained" color="primary" className={classes.DeleteOrderBtn}
                      onClick={() => handleDeleteCurrency(index, data, setData, setCount, handleDeleteCurrencyDialog)}>
                <FormattedMessage id='Page.Action.Delete'/>
              </Button>
              <Button onClick={handleDeleteCurrencyDialog} color="primary">
                <FormattedMessage id='ChangePhone.DialogActions.cancel'/>
              </Button>
            </DialogActions>
          </Dialog>
          }
        </>
      )}
    </CurrencyConsumer>
  )
}

export default DeleteCurrency
